import { render, staticRenderFns } from "./CollapseIndicator.vue?vue&type=template&id=04ee44b0&"
import script from "./CollapseIndicator.vue?vue&type=script&lang=ts&"
export * from "./CollapseIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ee44b0')) {
      api.createRecord('04ee44b0', component.options)
    } else {
      api.reload('04ee44b0', component.options)
    }
    module.hot.accept("./CollapseIndicator.vue?vue&type=template&id=04ee44b0&", function () {
      api.rerender('04ee44b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/CollapseIndicator.vue"
export default component.exports